'use client';

import ArrowRightIcon from '../icons/ArrowRightIcon';
import ArrowLeftIcon from '../icons/ArrowLeftIcon';

import styles from './Pagination.module.scss';
import { useSearchParams } from 'next/navigation';
import toNumber from 'lodash/toNumber';

const Pagination = props => {
  const { totalCount = 0, pageCount = 1, perPage = 0, changePage } = props;

  const searchParams = useSearchParams();
  const currentPage = toNumber(searchParams.get('page') || 1);

  if (!totalCount || !pageCount || !currentPage || !perPage) {
    return null;
  }

  return (
    <nav aria-label="page navigation">
      <ul className={`flex justify-center pagination ${styles?.pagination}`}>
        <li className="page-item">
          {currentPage - 1 >= 1 ? (
            <a
              className="page-link"
              onClick={() => changePage(currentPage - 1, perPage)}
            >
              <ArrowLeftIcon />
            </a>
          ) : (
            <span className={`page-link ${styles?.disabled}`}>
              <ArrowLeftIcon />
            </span>
          )}
        </li>

        {currentPage - 4 >= 1 ? (
          <>
            <li className="page-item">
              <a className="page-link" onClick={() => changePage(1, perPage)}>
                {1}
              </a>
            </li>
            <li className={`page-item ${styles.space}`}>
              <span className="page-link">...</span>
            </li>
          </>
        ) : (
          ''
        )}

        {currentPage - 2 >= 1 ? (
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => changePage(currentPage - 2, perPage)}
            >
              {currentPage - 2}
            </a>
          </li>
        ) : (
          ''
        )}

        {currentPage - 1 >= 1 ? (
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => changePage(currentPage - 1, perPage)}
            >
              {currentPage - 1}
            </a>
          </li>
        ) : (
          ''
        )}

        <li className="page-item">
          <span className={`page-link ${styles.active}`}>{currentPage}</span>
        </li>

        {currentPage + 1 <= pageCount ? (
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => changePage(currentPage + 1, perPage)}
            >
              {currentPage + 1}
            </a>
          </li>
        ) : (
          ''
        )}

        {currentPage + 2 <= pageCount ? (
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => changePage(currentPage + 2, perPage)}
            >
              {currentPage + 2}
            </a>
          </li>
        ) : (
          ''
        )}

        {currentPage + 4 <= pageCount ? (
          <>
            <li className={`${styles.space} page-item`}>
              <span className="page-link">...</span>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => changePage(pageCount, perPage)}
              >
                {pageCount}
              </a>
            </li>
          </>
        ) : (
          ''
        )}
        <li className="page-item">
          {currentPage + 1 <= pageCount ? (
            <a
              className="page-link"
              onClick={() => changePage(currentPage + 1, perPage)}
            >
              <ArrowRightIcon />
            </a>
          ) : (
            <span className={`page-link ${styles?.disabled}`}>
              <ArrowRightIcon />
            </span>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
